import React, { useState } from "react";
import { Mail, Check, Loader2, MapPin, Phone } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { SectionHeading } from "../components/Section";
import { submitContact } from "../lib/api";
import { useLang } from "../i18n/LanguageContext";
import { toast } from "sonner";

export default function Contact() {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));
  const submit = async (e) => { e.preventDefault(); setLoading(true); try { await submitContact(form); setSent(true); toast.success(t("contact.success")); } catch { toast.error("Error"); } finally { setLoading(false); } };

  return (
    <div className="pt-24 pb-16 container-lumeo">
      <SectionHeading eyebrow={t("nav.contact")} title={t("contact.title")} subtitle={t("contact.subtitle")} />
      <div className="grid lg:grid-cols-[1fr_360px] gap-8">
        {sent ? (
          <div className="rounded-2xl card-ceramic p-8 flex flex-col items-center justify-center text-center">
            <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-mintx/15 shadow-glow-mint"><Check className="h-8 w-8 text-mintx" /></span>
            <p className="mt-4">{t("contact.success")}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="rounded-2xl card-ceramic p-6 space-y-4" data-testid="contact-form">
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">{t("contact.name")}</Label><Input required value={form.name} onChange={set("name")} className="bg-[#0b0d12] border-border" /></div>
              <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">{t("contact.email")}</Label><Input required type="email" value={form.email} onChange={set("email")} className="bg-[#0b0d12] border-border" data-testid="contact-email" /></div>
            </div>
            <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">{t("contact.subject")}</Label><Input value={form.subject} onChange={set("subject")} className="bg-[#0b0d12] border-border" /></div>
            <div className="space-y-1.5"><Label className="text-xs text-muted-foreground">{t("contact.message")}</Label><Textarea required value={form.message} onChange={set("message")} rows={5} className="bg-[#0b0d12] border-border resize-none" /></div>
            <Button type="submit" disabled={loading} data-testid="contact-submit" className="w-full btn-glow border-0 h-12">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : t("contact.submit")}</Button>
          </form>
        )}
        <aside className="space-y-3">
          {[[Mail, "hello@lumeo.eu"], [Phone, "+387 33 000 000"], [MapPin, "Sarajevo \u00b7 EU"]].map(([Icon, v], i) => (
            <div key={i} className="flex items-center gap-3 rounded-xl card-ceramic p-4"><Icon className="h-5 w-5 text-cyanx" /><span className="text-sm">{v}</span></div>
          ))}
        </aside>
      </div>
    </div>
  );
}
